import { Component, ElementRef, Inject, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TermsComponent } from 'src/app/components/_shared/models/terms/terms.component';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { environment } from 'src/environments/environment';
import { debounce } from 'lodash'
import { messages } from '../../../../../common/messages'
import { url } from '../../../../../common/apiConstants';
import { states } from '../../../../../common/states';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { countryList } from '../../../../../common/country'
import { DOCUMENT } from '@angular/common';
import { regex,EmailNoWhitespaceValidator } from '../../../../../common/regex';
declare const google;
@Component({
    selector: 'app-pcv-sign-up',
    templateUrl: './pcv-sign-up.component.html',
    styleUrls: ['./pcv-sign-up.component.scss'],
    standalone: false
})
export class PcvSignUpComponent implements OnInit {


  //view child
  @ViewChild('lowerCase') private lowerCase: any;
  @ViewChild('upperCase') private upperCase: any;
  @ViewChild('oneNumeric') private oneNumeric: any;
  @ViewChild('minLength') private minLength: any;
  @ViewChild('symbol') private symbol: any;

  //variables
  signupFormGroup: any
  passwordFormGroup: any
  message: any;
  userId: any;
  assets = environment.assets;
  step: number = 1;
  passwordHasNumber: boolean = false;
  passwordHasUpper: boolean = false;
  passwordHasLower: boolean = false;
  passwordHasLength: boolean = false;
  urlList: any;
  statesList: Array<any> = [];
  hide = true;
  hide1 = true;
  hide2 = true;
  chide = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  countries
  malpracticeInsuranceExpiryDate = new FormControl('', [Validators.required]);
  imageUploadError: any = '';
  file: any;
  fileName: any = '';
  imageSrc: any = '';
  action: string;
  pwdPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?])[A-Za-z\d-+_!@#$%^&*., ?]{8,16}$/
  re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  lowerCaseRegex = /.*[a-z].*/
  upperCaseRegex = /.*[A-Z].*/
  oneNumericRegex = /.*\d.*/
  oneSymbol = /(?=.*[-+_!@#$%^&*., ?]).+/
  mask: '(000) 000-0000'
  // public mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  showDocPreview: boolean = false
  minDate = new Date();
  licenseExpiryDate = new FormControl(" ", [Validators.required]);
  licenseValidityFlag: boolean = true
  showPcv: boolean = false;
  showClinic: boolean = false;
  veterinarianFormGroup: FormGroup;
  ischeck: boolean = false;
  locationDetails: any = {};
  contactName: any = [];
  licenseInfo: any;
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _formBuilder: FormBuilder,
    private apiService: ApiService,
    private Utility: UtilityService,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit(): void {

    // this.statesList = states
    this.countries = countryList

    this.setupSignUpForm();
    this.setupVeterinarianSignUpForm();
    const tokens = this.route.snapshot.params.token;

    this.urlList = url
    this.message = messages

    this.passwordFormGroup = this._formBuilder.group({
      password: new FormControl("", [
        Validators.required,
        Validators.pattern(this.pwdPattern),
      ]),
      confirmPassword: new FormControl(''),
    }, {
      validator: this.comparePassword
    })

    if (tokens) {
      this.verifyEmail(tokens)
    }
  }
  setUserForm(event: any) {
    if (event.value === 'Individual Veterinarian') {
      this.showPcv = true;
    } else {
      this.showPcv = false;
    }
    if (event.value === 'Veterinary Clinic') {
      this.loadAutoComplete()
      this.showClinic = true;
    } else {
      this.showClinic = false;
    }
    this.checkEmail();
  }

  // Method to display states list as per country choosen
  setStateValue(event) {
    this.signupFormGroup.controls["otherCountry"].setValidators(null)
    this.signupFormGroup.controls["otherCountry"].updateValueAndValidity();
    let country = event.value
    if (country === 'Canada') {
      this.statesList = states.canadianStates
      this.signupFormGroup.patchValue({
        licenseState: ''
      })

    } else if (country === 'United States') {
      this.statesList = states.UnitedStates
      this.signupFormGroup.patchValue({
        licenseState: ''
      })

    } else if (country === 'Other') {
      // this.signupFormGroup.licenseState.setValue('Other')
      this.signupFormGroup.patchValue({
        licenseState: 'Other'
      })
      this.signupFormGroup.controls["otherCountry"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherCountry"].updateValueAndValidity();
      this.signupFormGroup.controls["otherLicenseState"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();
    } else {
      this.signupFormGroup.controls["otherCountry"].setValidators(null);
      this.signupFormGroup.controls["otherCountry"].updateValueAndValidity();
    }
  }
  //setup Sign up form 
  setupSignUpForm() {
    this.signupFormGroup = this._formBuilder.group({

      firstName: ['', Validators.compose([
        Validators.required,
      ])],

      lastName: ['', Validators.compose([
        Validators.required,
      ])],

      country: ['', Validators.compose([
        Validators.required,
        Validators.pattern(/^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*$/),
      ])],

      liabilityInsuranceProvider: ['', Validators.compose([
        Validators.required,

      ])],
      licenseNumber: ['', Validators.compose([
        Validators.required,
      ])],

      email: ['', Validators.compose([
        Validators.required,
        EmailNoWhitespaceValidator,
      ])],
      licenseState: [null, Validators.compose([
        Validators.required,
        Validators.pattern(/^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*$/),
      ])],
      otherLicenseState: [''],
      otherCountry: [''],
      

    })
  }




  employees(): FormArray {
    return this.veterinarianFormGroup.get("employees") as FormArray
  }


  newEmployee(): FormGroup {

    return this._formBuilder.group({
      dvmName: '',
      licenseNumber: '',
      country: '',
      licenseState: '',
      dvmlicenseExpiryDate: '',
      otherLicenseState: '',
    })
  }


  addEmployee() {
    if (this.veterinarianFormGroup.value.dvmContactName !== '' && this.veterinarianFormGroup.value.licenseNumber !== '' && this.veterinarianFormGroup.value.country !== '' && this.veterinarianFormGroup.value.dvmLicenseState !== '' && this.veterinarianFormGroup.value.dvmlicenseExpiryDate !== '') {
      this.employees().push(this.newEmployee());
    } else {
      this.Utility.openSnackBar("You need to fill DVM info first", "Error")
    }

  }


  removeEmployee(empIndex: number) {
    this.employees().removeAt(empIndex);
  }



  //setup Sign up form 
  setupVeterinarianSignUpForm() {
    this.veterinarianFormGroup = this._formBuilder.group({

      practiceName: ['', Validators.compose([
        Validators.required,
      ])],

      practiceAddress: [''],
      state: [''],
      city: [''],
      zipCode: [''],

      contactNumber: ['', Validators.compose([
        Validators.required,
      ])],
      employees: this._formBuilder.array([]),
      additionalDvmName: [''],
      dvmContactName: ['', Validators.compose([
        Validators.required,
      ])],
      licenseNumber: ['', Validators.compose([
        Validators.required,
      ])],
      country: ['', Validators.compose([
        Validators.required,
      ])],
      dvmLicenseState: ['', Validators.compose([
        Validators.required,
        Validators.pattern(/^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*$/),
      ])],
      otherLicenseState: [''],

      email: ['', Validators.compose([
        Validators.required,
        EmailNoWhitespaceValidator
      ])],
      checkMe: [false, Validators.compose([
        Validators.required,
      ])],
      secondaryContactName: [''],
      secondaryContactemail: [''],
      dvmlicenseExpiryDate: new FormControl("")
    })
  }
  checkBtn() {
    this.ischeck = !this.ischeck;
  }
  private loadAutoComplete() {
    const url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAuxw_Vyo9oWGyjEuDk34SykzfeIfeXfd0&libraries=places&v=weekly';

    this.loadScript(url).then(() => {
      this.initAutocomplete()
    })

  }

  private loadScript(url) {
    return new Promise((resolve, reject) => {

      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.text = ``;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer2.appendChild(this.document.head, script);
    })
  }
  initAutocomplete() {

    const input = document.getElementById("txtSearchPlaces1") as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.setFields([
      "address_components",
      "geometry",
      "icon",
      "name"
    ]);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        alert('No details available for input:' + input.value);
        return;
      } else {
        this.ngZone.run(() => {
          this.locationDetails = this.Utility.getAllLocationDetails(place)
          this.veterinarianFormGroup.controls["country"].setValue(this.locationDetails.country);
          this.veterinarianFormGroup.controls["practiceAddress"].setValue(this.locationDetails.address);
          this.veterinarianFormGroup.controls["state"].setValue(this.locationDetails.state);
          this.veterinarianFormGroup.controls["city"].setValue(this.locationDetails.city);
          this.veterinarianFormGroup.controls["zipCode"].setValue(this.locationDetails.zipcode);
          
          if (this.locationDetails.country === 'Canada') {
            this.statesList = states.canadianStates
          } else if (this.locationDetails.country === 'United States') {
            this.statesList = states.UnitedStates
          } else {
            this.statesList = []
          }
        })



        return;
      }
    });
  }

  /**
 * Compares password and confirm password are they same or not
 */
  comparePassword(control: any) {

    let password = control.get("password").value
    let confirmPassword = control.get("confirmPassword").value
    if (confirmPassword.length != '') {
      if (password !== confirmPassword) {
        control.get("confirmPassword").setErrors({ passwordCompare: true })
      }
      else {
        control.get("confirmPassword").setErrors(null)
      }
    }
    else {
      control.get("confirmPassword").setErrors({ invalid: true })
    }

  }

  //method used to verify Email
  verifyEmail(token: string) {
    this.Utility.setSpinner(true);

    this.apiService.apiRequest("post", "user/verifyEmail", { tokens: token })
      .subscribe((res) => {
        if (res) {
          this.userId = res.data.userId
          this.Utility.openSnackBar(res.data.message, "Ok")
          this.step = 2;
          this.Utility.setSpinner(false);

        }
      }, (err) => {
        this.Utility.setSpinner(false);
        if (err?.status === 400 && err?.error?.status === 'invalidToken') {
          this.Utility.openSnackBar("This verification link is no longer valid. Please use the latest verification email.", "Ok")
        } else {
          this.Utility.openSnackBar("Email verification link expired.", "Ok")
        }
        this.router.navigate(['/404']); // Navigate to 404 page for invalid/expired tokens

      })
  }

  //method called after signup form is filled and user clicks on signup
  submitForm() {
    
    if (!this.licenseExpiryDate.valid) {
      console.error('License expiry date is not valid');
      this.licenseExpiryDate.markAsTouched();
      return;
    }
    
    if (!this.malpracticeInsuranceExpiryDate.valid) {
      console.error('Malpractice insurance expiry date is not valid');
      this.malpracticeInsuranceExpiryDate.markAsTouched();
      return;
    }

    if (this.fileName != '') {
      this.Utility.setSpinner(true)
      let licenseInfo = {
        licenseNumber: this.signupFormGroup.value.licenseNumber,
        licenseState: this.signupFormGroup.value.licenseState,
        otherLicenseState: this.signupFormGroup.value.otherLicenseState,
        licenseExpiryDate: this.licenseExpiryDate.value

      }
      let fd = new FormData()

      fd.append("firstName", this.signupFormGroup.value.firstName.trim())
      fd.append("lastName", this.signupFormGroup.value.lastName.trim())
      fd.append("email", this.signupFormGroup.value.email.toLowerCase())
      fd.append("country", this.signupFormGroup.value.country)
      fd.append("malpracticeInsuranceExpiryDate", this.malpracticeInsuranceExpiryDate?.value || '')
      fd.append("liabilityInsuranceProvider", this.signupFormGroup.value.liabilityInsuranceProvider)
      fd.append("licenseInfo", JSON.stringify(licenseInfo))
      fd.append("otherCountry", this.signupFormGroup.value.otherCountry)
      fd.append("userType", 'pcv')

      if (this.file) {
        fd.append("doc", this.file)
      }

      this.apiService.apiRequest("post", this.urlList.routes.signupSpecialist, fd)
        .subscribe((res) => {
          this.Utility.setSpinner(false);
          this.setupSignUpForm();
          this.Utility.openSnackBar("A verification email has been been sent to your registered email ID. Please check your Inbox", "Ok")
          this.imageUploadError = ''
          this.imageSrc = ''
          this.malpracticeInsuranceExpiryDate.reset()
          this.licenseExpiryDate.reset()

          this.showDocPreview = false
        }, (err) => {
          this.Utility.setSpinner(false)
        })
    } else {
      this.imageUploadError = "Please upload image driving license/other state issued ID"
    }
  }
  //method called after signup form is filled and user clicks on signup
  submitClinicForm() {
    if (this.fileName != '') {
      this.Utility.setSpinner(true)
      let licenseInfo = [{
        licenseNumber: this.veterinarianFormGroup.value.licenseNumber,
        licenseState: this.veterinarianFormGroup.value.dvmLicenseState,
        otherLicenseState: this.veterinarianFormGroup.value.otherLicenseState,
        dvmlicenseExpiryDate: this.veterinarianFormGroup.value.dvmlicenseExpiryDate,
        dvmName: this.veterinarianFormGroup.value.dvmContactName

      }]
      licenseInfo.push(...this.veterinarianFormGroup.value.employees);
      let fd = new FormData()

      fd.append("practiceName", this.veterinarianFormGroup.value.practiceName.trim())
      fd.append("practiceAddress", this.veterinarianFormGroup.value.practiceAddress.trim())
      fd.append("city", this.veterinarianFormGroup.value.city.trim())
      fd.append("zipCode", this.veterinarianFormGroup.value.zipCode.trim())
      fd.append("stateOfPractice", this.veterinarianFormGroup.value.state.trim())
      fd.append("email", this.veterinarianFormGroup.value.email.toLowerCase())
      fd.append("country", this.veterinarianFormGroup.value.country)
      fd.append("contactNumber", this.veterinarianFormGroup.value.contactNumber)
      fd.append("contactName", this.veterinarianFormGroup.value.dvmContactName)
        fd.append("dvmInfo", JSON.stringify(licenseInfo)),
        fd.append("secondaryEmail", this.veterinarianFormGroup.value.secondaryContactemail),
      fd.append("otherCountry", this.signupFormGroup.value.otherCountry)
      fd.append("userType", 'vc')

      if (this.file) {
        fd.append("doc", this.file)
      }
      this.apiService.apiRequest("post", this.urlList.routes.signupSpecialist, fd)
        .subscribe((res) => {
          this.Utility.setSpinner(false);
          this.setupVeterinarianSignUpForm();
          this.Utility.openSnackBar("A verification email has been been sent to your registered email ID. Please check your Inbox", "Ok")
          this.imageUploadError = ''
          this.imageSrc = ''
          this.licenseExpiryDate.reset()
          this.checkBtn()

          this.showDocPreview = false
        }, (err) => {
          this.Utility.setSpinner(false)
        })

    } else {
      this.imageUploadError = "Please upload image of DVM contact"
    }

  }


  readImage = (event: any) => {
    let error
    if (event.target.files && event.target.files[0]) {
      error = this.validateFile(event.target.files[0])
      if (error == '') {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.imageSrc = reader.result;
        reader.readAsDataURL(file);
        this.fileName = event.target.files[0].name
        this.file = event.target.files[0]
        this.showDocPreview = true;
        this.action = ''
      } else {
        this.imageUploadError = error

      }

    }
  }

  validateFile(file) {
    this.imageUploadError = ''
    const allowedExt = ["png", "jpg", "jpeg"]
    const maxfilesize = 8 * 1024 * 1024

    const fileNameArray = file.name.split(".")
    const extension = fileNameArray[fileNameArray.length - 1]

    if (allowedExt.indexOf(extension.toLowerCase()) == -1) {
      return "Allowed Extension are " + allowedExt.join(", ")
    } else if (file.size > maxfilesize) {
      return "File size should not exceed 8 MB."
    } else {
      return ''
    }
  }

  deleteFile() {
    this.showDocPreview = false
    this.fileName = ''
    this.file = ''
  }

  // method check if  email is already in use
  checkEmail() {
    if ((this.showPcv && this.signupFormGroup.controls.email.status === "VALID") || (this.showClinic && this.veterinarianFormGroup.controls.email.status === "VALID")) {

      let reqBody = {
        email: this.showPcv ? this.signupFormGroup.controls.email.value.toLowerCase() : this.veterinarianFormGroup.controls.email.value.toLowerCase()
      }
      this.apiService.apiRequest("post", "user/getUserByEmail", reqBody).subscribe((res) => {
        if (res.status == "success") {
          if(this.showPcv){
          this.signupFormGroup.controls["email"].setErrors({ isEmailExist: true });
          }
          if(this.showClinic){
          this.veterinarianFormGroup.controls["email"].setErrors({ isEmailExist: true });
          }
        }
        else {
          this.signupFormGroup.controls["email"].setErrors(null);
          this.veterinarianFormGroup.controls["email"].setErrors(null);
        }
      }, (err) => {

      }
      )
    }
  }

  // method check if license numbr is already in use
  checkLicenseNumber() {
    if (this.signupFormGroup.controls.licenseNumber.status === "VALID") {

      let reqBody = {
        licenseNumber: this.signupFormGroup.controls.licenseNumber.value
      }
      this.apiService.apiRequest("post", "user/getUserByLicenseNumber", reqBody).subscribe((res) => {
        if (res) {
          this.signupFormGroup.controls["licenseNumber"].setErrors({ isLicenseNumberExist: true });
        }
        else {
          this.signupFormGroup.controls["licenseNumber"].setErrors(null);
        }
      }, (err) => {

      }
      )
    }
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').match(/\s/g)
    const isValid = !isWhitespace
    return isValid ? null : { 'whitespace': true }
  }


  //method to check and uncheck given password conditions
  checkPassword = debounce(() => {

    let password = this.passwordFormGroup.controls.password.value

    if (this.oneNumericRegex.test(password)) {
      this.oneNumeric.checked = true
    } else {
      this.oneNumeric.checked = false

    }

    if (password.length >= 8) {
      this.minLength.checked = true;
    } else {
      this.minLength.checked = false;
    }

    if (this.lowerCaseRegex.test(password)) {
      this.lowerCase.checked = true
    } else {
      this.lowerCase.checked = false
    }

    if (this.upperCaseRegex.test(password)) {
      this.upperCase.checked = true
    } else {
      this.upperCase.checked = false

    }
    if (this.oneSymbol.test(password)) {
      this.symbol.checked = true
    } else {
      this.symbol.checked = false

    }

  }, 350)

  openTermsAndDocument() {
    this.dialog.open(TermsComponent).afterClosed().subscribe(response => {
      if (response == 'Accept') {

        let userDetails = {

          password: this.passwordFormGroup.value.password,
          "isAgreementAccepted": true,
          "userId": this.userId
        }
        this.Utility.setSpinner(true);
        this.apiService.apiRequest("post", "user/setupPassword", userDetails)
          .subscribe((res) => {
            this.Utility.setSpinner(false);
            let userData = res.data.userDetails
            // // Store the values in local storage
            if (userData.userType === 'pcv') {
                localStorage.setItem("endUserEmail", userData.email)
                localStorage.setItem("endUserId", userData._id)
                localStorage.setItem("endUserType", userData.userType)
                localStorage.setItem("endUserFullName", userData.firstName + ' ' + userData.lastName)
                localStorage.setItem("endUserFirstName", userData.firstName)
                localStorage.setItem("endUserLastName", userData.lastName)
                localStorage.setItem("accessToken", userData.accessToken)
                localStorage.setItem("contactNumber", userData.contactNumber)
                localStorage.setItem("profilePic", userData.profilePic);
            }else{
                localStorage.setItem("endUserEmail", userData.email)
                localStorage.setItem("endUserId", userData._id)
                localStorage.setItem("endUserType", userData.userType)
                localStorage.setItem("endUserFullName", userData.practiceName)
                localStorage.setItem("accessToken", userData.accessToken)
                localStorage.setItem("contactNumber", userData.contactNumber)
                localStorage.setItem("status", userData.status)
            }

            this.Utility.openSnackBar(res.data.message, "Ok")
            this.router.navigate(['pcv/dashboard']);
          }, (err) => {
            this.Utility.openSnackBar("Something went wrong.", "Ok")
            this.Utility.setSpinner(false);

          })
      } else {
        this.router.navigate(['primary-care-veterinarian']);
      }
    });
  }
  goToSetPassword = () => {
    this.step = 2;
    window.scrollTo(0, 0);
  }


  checkPasswordValidation = (value: any) => {
    this.passwordHasNumber = /\d/.test(value);
    this.passwordHasUpper = /[A-Z]/.test(value);
    this.passwordHasLower = /[a-z]/.test(value);
    this.passwordHasLength = value.length >= 8;
  }

  checkOtherOption(event) {
    let state = event.value
    if (state == 'Other') {
      this.signupFormGroup.controls["otherLicenseState"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();


    } else {
      this.signupFormGroup.controls["otherLicenseState"].setValidators(null);
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();
    }
  }
  // onSubmitSignUp = (form:NgForm) => {
  //   if (form.invalid) {
  //     return;
  //   }
  //   this.dialog.open(TermsComponent).afterClosed().subscribe(response=>{
  //     if (response=='Accept') {
  //       this.router.navigate(['pcv/dashboard']);
  //     }
  //   });
  // }

}
